import React from "react";
import { Outlet } from "react-router-dom";
import BaseTemplate from "./BaseTemplate";

export default function PageLayout() {
  return (
    <BaseTemplate>
      <Outlet />
    </BaseTemplate>
  );
}
